<template>
    <ul class="social-share">
        <li v-for="(item, index) in share" :key="index" :item="share" class="social-share__item">
            <a
                :href="links[item]"
                target="_blank"
                rel="noopener noreferrer"
                :class="`social-share__link social-share__link--${item}`"
            >
                <NuxtIcon v-if="item === 'email'" :name="`ri:mail-fill`" class="bg-orange-400" />
                <NuxtIcon v-if="item === 'facebook'" :name="`ri:facebook-box-fill`" class="bg-blue-600" />
                <NuxtIcon v-if="item === 'twitter'" :name="`ri:twitter-x-fill`" class="bg-black" />
                {{ t('socials_share.share_on') }} {{ item }}
            </a>
        </li>
    </ul>
</template>

<script setup lang="ts">
defineProps({ share: { type: Object } });

const { t } = useI18n();

const shareUrl = typeof window !== 'undefined' ? encodeURIComponent(window.location.href) : '';
const shareMessage = encodeURIComponent(t('socials_share.check_airport_guide'));

const links = {
    facebook: `https://www.facebook.com/share.php?u=${shareUrl}`,
    email: `mailto:?Subject=${shareMessage}&amp;body=${shareMessage} ${shareUrl}`,
    twitter: `https://twitter.com/intent/tweet?hashtags=travel,traveltip%20${shareMessage}%20${shareUrl}`,
};
</script>

<style lang="postcss" scoped>
.social-share {
    @apply flex gap-1 float-right;
    &__item {
        font-size: 0;
    }
    &__link {
        @apply inline-block w-[23px] h-[23px];
        font-size: 0;
        .iconify {
            @apply w-[23px] h-[23px];
        }
    }
}
</style>
